import { GenericSuspense } from "@mzara/component";
import { Outlet } from "react-router-dom";

const AdminContainer = () => {
    return (
        <GenericSuspense>
            <Outlet />
        </GenericSuspense>
    );
};

export default AdminContainer;
